module.exports = __webpack_public_path__ + "img/1510036791.34c8a48b.jpg";